export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#0f7ccf',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: '/images/sindipelotas.png',
  favicon: '/favicon-sind-pelotas.png',
}

export const seo = {
  titulo: 'Sindicato dos Contadores e Técnicos em Contabilidade da Cidade de Pelotas e Região',
  email: 'suporte@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado curitiba',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: false,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: true,
  contaLogin: true,
}

export const contentHome = {
  sispass: true,
  produtorRural: true,
  modalidadesCertificado: true,
  ratingGoogle: false,
}

export const footer = {
  is0800: true,
  telefone: '53 9 81035000',
  whatsapp: '53 9 81035000',
  botaoRenocao: '4192848223',
  comercial: '4195227449',
  marketing: '41 2391-4237',
  botaoWhatsapp: '53 9 81035000',
  number0800: '0800 600 2710',
  cidadeuf: 'Pelotas - RS',
  cidade: 'Pelotas',
  bairro: 'Centro',
  titulo: 'Certificado Digital em Pelotas',
  rua: 'Rua General Argolo',
  numero: '593',
  complemento: '',
  cep: '96015160',
  cnpj: '92.237.643/0001-71',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Senha Digital',
}

export const redes = {
  facebook: 'https://www.facebook.com/senhadigitaloficial/',
  instagram: 'https://www.instagram.com/senhadigital/',
  linkedin: 'https://www.linkedin.com/company/senhadigitaloficial/mycompany/',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: true,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
